import React, { Component, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { mergeStyleSets } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, MessageBarButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, ConstrainMode, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { MessageBars } from '../Outils/MessageBars';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataNews } from '../../data/DataNews';
import { IDS_TYPE_MANDAT } from '../../data/DataTypeMandat';

import { FicheNews } from '../Fiche/FicheNews';
import { FromDateToDatePicker } from '../Outils/FromDateToDatePicker';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

/*
***************************************************************
 PROPS: aucune
***************************************************************
*/

//#region CSS
const classNames = mergeStyleSets({
    fullCircleMaskIcon: {
        color: "green",
        fontSize: "1rem",
        textAlign: "center",
    }
});
//#endregion

export class DetailsListNews extends Component {

    filterBy = {};
    include = { idsTypeMandat: true };
    sortedColumn = "creerLe";
    isSortedDescending = true;

    constructor(props) {
        super(props);

        const columns = [
            {
                key: 'idNews',
                minWidth: 25,
                maxWidth: 25,
                name: 'ID',
                onRender: (item) => {
                    return <span className="badge badge-secondary">{item.idNews}</span>;
                }
            },
            {
                isResizable: true,
                key: 'titre',
                minWidth: 100,
                maxWidth: 150,
                name: 'Titre',
                onRender: (item) => {
                    let titre = item.titre;
                    return <span title={titre}>{titre}</span>;
                }
            },
            {
                isResizable: true,
                key: 'contenu',
                minWidth: 100,
                name: 'Message',
                onRender: (item) => {
                    let contenu = item.contenu;
                    return <span title={contenu}>{contenu}</span>;
                }
            },
            {
                isSorted: true,
                isSortedDescending: false,
                isResizable: true,
                key: 'creerLe',
                minWidth: 75,
                maxWidth: 75,
                name: 'Créée le',
                onRender: (item) => {
                    return <span>{Scriba.date().stringDateFormatCourt(item.creerLe)}</span>;
                }
            },
            {
                iconName: "Suitcase",
                isIconOnly: true,
                key: 'commercialisateur',
                minWidth: 25,
                maxWidth: 25,
                onRender: (item) => {
                    return (item.idsTypeMandat.includes(IDS_TYPE_MANDAT.COMMERCIALISATEUR) ? <Icon title="Commercialisateur" iconName="FullCircleMask" className={classNames.fullCircleMaskIcon} /> : null);
                }
            },
            {
                iconName: "TextDocument",
                isIconOnly: true,
                key: 'gestionnaireDeMandat',
                minWidth: 25,
                maxWidth: 25,
                onRender: (item) => {
                    return (item.idsTypeMandat.includes(IDS_TYPE_MANDAT.GESTIONNAIRE_MANDAT) ? <Icon title="Gestionnaire de mandats" iconName="FullCircleMask" className={classNames.fullCircleMaskIcon} /> : null);
                }
            },
            {
                iconName: "Settings",
                isIconOnly: true,
                key: 'operationnel',
                minWidth: 25,
                maxWidth: 25,
                onRender: (item) => {
                    return (item.idsTypeMandat.includes(IDS_TYPE_MANDAT.OPERATIONNEL) ? <Icon title="Opérationnel" iconName="FullCircleMask" className={classNames.fullCircleMaskIcon} /> : null);
                }
            },
            {
                iconName: "WorkforceManagement",
                isIconOnly: true,
                key: 'directionCommerciale',
                minWidth: 25,
                maxWidth: 25,
                onRender: (item) => {
                    return (item.idsTypeMandat.includes(IDS_TYPE_MANDAT.DIRECTEUR_COMMERCIAL) ? <Icon title="Direction commerciale" iconName="FullCircleMask" className={classNames.fullCircleMaskIcon} /> : null);
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: 'edit',
                minWidth: 25,
                maxWidth: 25,
                name: 'Consulter',
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: 'Edit' }}
                        onClick={() => this._onClickOpenFicheNews(item)}
                        title="Modifier la news"
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: 'delete',
                minWidth: 25,
                maxWidth: 25,
                name: 'Supprimer',
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: 'Trash' }}
                        onClick={() => this._onClickOpenDialogSuppressionNews(item)}
                        title="Supprimer la news"
                    />;
                }
            }
        ];

        this.state = {
            items: [],
            activeNews: {},

            columns: columns,
            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            isOpenPanelFiltres: false,
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: '',
            messageMessageBarFiltres: ''
        };
    }

    _creationContent = () => {
        return <DetailsList
            columns={this.state.columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />
    }

    _chargementDonnees = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des news en cours'
            });

            let chargementNews = DataNews._onChargementNews(this.filterBy, this.include, this.sortedColumn, this.isSortedDescending);

            chargementNews
                .then(responseFetch => {
                    const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                    let newState = {
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage
                    };
                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        //YD : 17/06/2020 : Ajout test sur listeItem != null
                        let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);

                        newState.items = listeItem;
                    };
                    this.setState(newState);
                });
        }
    };

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: this.state.items ? this.state.items.length : 0
            },
            {
                key: 'filtres',
                iconOnly: true,
                iconProps: { iconName: 'Filter' },
                name: 'Filtres',
                onClick: () => this._onClickOpenPanelFiltres()
            }
        ];
    };

    _getItems = () => {
        return [
            {
                key: 'search',
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            },
            {
                key: 'addNews',
                name: 'Publier une news',
                iconProps: { iconName: 'Add' },
                onClick: () => this._onClickOpenFicheNews(null)
            }
        ];
    };

    _onApplyFilters = (filters) => {
        this.setState({ isOpenPanelFiltres: false });
        this.filterBy = filters;
        this._chargementDonnees();
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        if (!['commercialisateur', 'gestionnaireDeMandat', 'operationnel'].includes(key)) {

            const { columns } = this.state;
            const newColumns = columns.slice();
            const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

            newColumns.forEach((newCol) => {
                if (newCol === currColumn) {
                    currColumn.isSortedDescending = !currColumn.isSortedDescending;
                    currColumn.isSorted = true;
                } else {
                    newCol.isSorted = false;
                    newCol.isSortedDescending = false;
                }
            });

            this.sortedColumn = key;
            this.isSortedDescending = typeof column.isSortedDescending !== 'undefined' && column.isSortedDescending;
            this._chargementDonnees();
        }
    };

    _onClickOpenFicheNews = (activeNews) => {
        activeNews = activeNews || { idNews: 0, titre: "", contenu: "", idsTypeMandat: [] }
        this.setState({
            activeNews: activeNews,
            isOpenFicheNews: true
        });
    };

    _onClickOpenDialogSuppressionNews = (activeNews) => {
        this.setState({
            activeNews: activeNews,
            isOpenDialogSuppressionNews: true
        });
    };

    _onClickOpenPanelFiltres = () => {
        this.setState({ isOpenPanelFiltres: true });
    };

    _onClickSuppressionNews = () => {
        this._onDismissDialogSuppressionNews();
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression en cours'
        });

        var suppressionNews = DataNews._onSuppressionNews(this.state.activeNews.idNews);

        suppressionNews
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    };

    _onDismissDialogSuppressionNews = () => {
        this.setState({ isOpenDialogSuppressionNews: false });
    };

    _onDismissFicheNews = () => {
        this.setState({ isOpenFicheNews: false });
    };

    _onDismissPanelFiltres = () => {
        this.setState({ isOpenPanelFiltres: false });
    };

    _onEnregistrementFicheNews = () => {
        this.setState({ isOpenFicheNews: false });
        this._chargementDonnees();
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onSearch = (text) => {
        this.filterBy.keyword = text;
        this._chargementDonnees();
    };

    componentDidMount() {
        this._chargementDonnees();
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheNews
                isOpen={this.state.isOpenFicheNews}
                news={this.state.activeNews}
                onDismiss={this._onDismissFicheNews}
                onEnregistrement={this._onEnregistrementFicheNews}
            />

            <PanelFiltresNews
                fromDate={this.filterBy.fromDate}
                idsTypeMandat={this.filterBy.idsTypeMandat}
                isOpen={this.state.isOpenPanelFiltres}
                onApplyFilters={(filters) => this._onApplyFilters(filters)}
                onDismiss={this._onDismissPanelFiltres}
                toDate={this.filterBy.toDate}
            />

            <Dialog
                hidden={!this.state.isOpenDialogSuppressionNews}
                onDismiss={this._onDismissDialogSuppressionNews}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: "Suppression news #" + this.state.activeNews.idNews,
                    subText: "La news « " + this.state.activeNews.titre + " » sera supprimée définitivement, confirmez-vous ce choix ?"
                }}
                modalProps={{
                    isBlocking: false,
                    styles: { main: { maxWidth: 450 } }
                }}>
                <DialogFooter>
                    <PrimaryButton onClick={this._onClickSuppressionNews} text="Confirmer" />
                    <DefaultButton onClick={this._onDismissDialogSuppressionNews} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    };
};

const PanelFiltresNews = (props) => {

    /*
    ******************************************************************************************************
    PROPS :
        ATTRIBUTS :
            int[]   idsTypeMandat               tableau des IdTypeMandat
            date    fromDate                    date de publication (fourchette basse)
            date    toDate                      date de publication (fourchette haute)
            bool    isOpen                      détermine si panel ouvert ou non
        METHODES :
            void    onApplyFilters(filters)     méthode appelée lorsque l'utilisateur clique sur "Valider"
            void    onDismiss                   méthode appelée lorsque l'utilisateur clique sur "Annuler"
    ******************************************************************************************************
    */

    const [idsTypeMandat, setIdsTypeMandat] = useState(props.idsTypeMandat);
    const [fromDate, setFromDate] = useState(props.fromDate);
    const [toDate, setToDate] = useState(props.toDate);

    const _onChangeToggle = (checked, idTypeMandat) => {
        let idsTypeMandatUpdates = [...idsTypeMandat];

        if (checked)
            idsTypeMandatUpdates.push(idTypeMandat);
        else
            idsTypeMandatUpdates = idsTypeMandatUpdates.filter((value) => value !== idTypeMandat);

        setIdsTypeMandat(idsTypeMandatUpdates);
    };

    const _onClickApplyFilters = () => {
        const filters = {
            idsTypeMandat: idsTypeMandat,
            fromDate: fromDate,
            toDate: toDate
        };
        props.onApplyFilters(filters);
    };

    const _onClickResetFilters = () => {
        setIdsTypeMandat([]);
        setFromDate(undefined);
        setToDate(undefined);
    };

    const _onOpen = () => {
        setIdsTypeMandat(props.idsTypeMandat);
        setFromDate(props.fromDate);
        setToDate(props.toDate);
    };

    const _onRenderFiltresFooterContent = () => {
        return (
            <Fragment>
                <PrimaryButton onClick={_onClickApplyFilters} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={props.onDismiss}>Fermer</DefaultButton>
            </Fragment>
        );
    };

    const _onSelectFiltreDate = (fromDate, toDate) => {
        setFromDate(fromDate);
        setToDate(toDate);
    };

    return <Panel
        closeButtonAriaLabel="Fermer"
        headerText="Filtres"
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onOpen={_onOpen}
        onRenderFooterContent={_onRenderFiltresFooterContent}
        type={PanelType.smallFixedFar}
    >
        <Stack>
            <Stack.Item align="end">
                <IconButton
                    iconProps={{ iconName: 'ClearFilter' }}
                    className="buttonFiltres"
                    title="Réinitialiser les filtres"
                    ariaLabel="Filtres"
                    onClick={_onClickResetFilters}
                />
            </Stack.Item>
            {
                [
                    { label: "Commercialisateurs", iconName: "Suitcase", idTypeMandat: IDS_TYPE_MANDAT.COMMERCIALISATEUR },
                    { label: "Gestionnaires de mandats", iconName: "TextDocument", idTypeMandat: IDS_TYPE_MANDAT.GESTIONNAIRE_MANDAT },
                    { label: "Opérationnels", iconName: "Settings", idTypeMandat: IDS_TYPE_MANDAT.OPERATIONNEL },
                    { label: "Direction commerciale", iconName: "WorkforceManagement", idTypeMandat: IDS_TYPE_MANDAT.DIRECTEUR_COMMERCIAL }
                ]
                    .map((element, index) => <Toggle
                        checked={idsTypeMandat && idsTypeMandat.includes(element.idTypeMandat)}
                        inlineLabel
                        key={index}
                        label={
                            <Stack horizontal horizontalAlign="center">
                                <Icon iconName={element.iconName} />
                                <span className="pl-1 pr-3">{element.label}</span>
                            </Stack>
                        }
                        onChange={(event, checked) => _onChangeToggle(checked, element.idTypeMandat)}
                    />
                    )
            }
            <FromDateToDatePicker
                fromDate={fromDate}
                toDate={toDate}
                onSelectDate={(fromDate, toDate) => _onSelectFiltreDate(fromDate, toDate)}
            />
        </Stack>
    </Panel>

};

PanelFiltresNews.propTypes = {
    idsTypeMandat: PropTypes.arrayOf(PropTypes.number),
    fromDate: PropTypes.instanceOf(Date),
    toDate: PropTypes.instanceOf(Date),
    isOpen: PropTypes.bool.isRequired,
    onClickApplyFilters: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
};

PanelFiltresNews.defaultProps = {
    idsTypeMandat: []
};